export default "__VITE_ASSET__DpHRNkkY__"